export function createElement(tag, options = {}) {
  const script = document.createElement(tag)
  Object.keys(options).forEach((key) => {
    script[key] = options[key]
  })

  return script
}
